import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=7b9a8380"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=7b9a8380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports